var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"manual":"","value":_vm.tooltipVisible,"disabled":!_vm.truncated,"content":_vm.label,"tabindex":-1,"enterable":false,"placement":"right","effect":"dark"}},[_c('span',{staticClass:"personal-menu-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }